import FuseSearch from '@fuse/core/FuseSearch';
import AppBar from '@mui/material/AppBar';
import useMediaQuery from '@mui/material/useMediaQuery';
import { ThemeProvider, StyledEngineProvider, useTheme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import Toolbar from '@mui/material/Toolbar';
import Logo from 'app/fuse-layouts/shared-components/Logo';
import NavbarMobileToggleButton from 'app/fuse-layouts/shared-components/NavbarMobileToggleButton';
import QuickPanelToggleButton from 'app/fuse-layouts/shared-components/quickPanel/QuickPanelToggleButton';
import UserMenu from 'app/fuse-layouts/shared-components/UserMenu';
import clsx from 'clsx';
import React from 'react';
import { useSelector } from 'app/modules/react-redux';
import LanguageSwitcher from '../../shared-components/LanguageSwitcher';

const useStyles = makeStyles((theme) => ({
	separator: {
		width: 1,
		height: 64,
		backgroundColor: theme.palette.divider,
	},
}));

const ToolbarLayout3 = (props) => {
	const config = useSelector(({ fuse }) => fuse.settings.current.layout.config);
	const toolbarTheme = useSelector(({ fuse }) => fuse.settings.toolbarTheme);

	const classes = useStyles(props);
	const theme = useTheme();
	const lgUp = useMediaQuery(theme.breakpoints.up('lg'));
	const lgDown = useMediaQuery(theme.breakpoints.down('lg'));
	const smUp = useMediaQuery(theme.breakpoints.up('sm'));
	const smDown = useMediaQuery(theme.breakpoints.down('sm'));

	return (
		<StyledEngineProvider injectFirst>
			(
			<ThemeProvider theme={toolbarTheme}>
				<AppBar
					id="fuse-toolbar"
					className="flex relative z-10"
					color="default"
					style={{ backgroundColor: toolbarTheme.palette.background.default }}
				>
					<Toolbar className="container p-0 lg:px-24">
						{config.navbar.display && lgDown && (
							<>
								<NavbarMobileToggleButton className="w-64 h-64 p-0" />
								<div className={classes.separator} />
							</>
						)}

						{lgUp && (
							<div className={clsx('flex flex-shrink-0 items-center')}>
								<Logo />
							</div>
						)}

						<div className="flex flex-1">
							{smUp && <FuseSearch className="mx-16 lg:mx-24" variant="basic" />}
						</div>

						<div className="flex">
							{smDown && (
								<>
									<FuseSearch />
									<div className={classes.separator} />
								</>
							)}

							<UserMenu />

							<div className={classes.separator} />

							<LanguageSwitcher />

							<div className={classes.separator} />

							<QuickPanelToggleButton />

							{lgUp && <div className={classes.separator} />}
						</div>
					</Toolbar>
				</AppBar>
			</ThemeProvider>
			)
		</StyledEngineProvider>
	);
};

export default React.memo(ToolbarLayout3);
